import { Component, OnInit } from '@angular/core';

import { UtilityService, AuthService, AppInformationService, ArkUnitOfWork, SessionInformationService } from 'app/core/core.module';
import { DevExtremeModule } from 'devextreme-angular';
import { confirm, alert } from 'devextreme/ui/dialog';

@Component({
    selector: 'app-statements',
    templateUrl: './statements.component.html',
    styleUrls: ['./statements.component.scss'],
    standalone: true,
    imports: [DevExtremeModule],
})
export class StatementsComponent implements OnInit {
    families: any[];
    filter: {
        givingYear: any;
        email: any;
        birthDate: Date;
        budgetBox: any;
        code: string;
    };
    givingYears: any;
    givingInfo: any;
    processing = false;
    dataLoaded = false;
    validated = false;
    memberCode: string;
    message = 'Contact Office to Request Authorization';

    constructor(private utility: UtilityService, private appInfo: AppInformationService, private sessionInfo: SessionInformationService) {}

    async ngOnInit() {
        this.memberCode = this.sessionInfo.getItem('memberCode');
        if (!this.memberCode) {
            this.message = 'No member information.  Verify portal login.';
            this.dataLoaded = true;
            return;
        }
        this.appInfo.pleaseWaitShow();
        try {
            this.givingInfo = await this.utility.getMemberStatementPageInfo(this.memberCode);
            console.log(this.givingInfo);
            if (!this.givingInfo.result) {
            } else {
                this.validated = true;
                this.givingYears = this.givingInfo.givingYears;
                this.filter = { givingYear: this.givingYears[this.givingYears.length - 1], email: '', birthDate: new Date(), budgetBox: null, code: null };
            }
            this.appInfo.pleaseWaitHide();
            this.dataLoaded = true;
        } catch (error) {
            this.message = 'Something went wrong.  Contact administrator.  Error: Member code invalid';
            this.dataLoaded = true;
            this.appInfo.pleaseWaitHide();
        }
        this.appInfo.pleaseWaitHide();
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift({
            location: 'before',
            template: 'toolbarButtons',
        });
    }

    async getStatement(getCode?: boolean) {
        if (!this.filter.givingYear || !this.filter.email || !this.filter.birthDate || !this.filter.budgetBox || !this.filter.code) {
            await (<Promise<any>>alert(`Fill in the required information`, 'Error'));
            return;
        }
        this.processing = true;
        this.appInfo.pleaseWaitShow();
        let result = '';
        if (getCode) {
            result = (await this.utility.getMemberCode(this.filter)) as string;
        } else {
            result = (await this.utility.getMemberStatement(this.filter)) as string;
        }
        await (<Promise<any>>alert(`${result}`, 'Graafschap ARK'));
        this.appInfo.pleaseWaitHide();
        this.processing = false;
    }
}
